/* src/messages/cards/MessageListCard/styles.js */

export default theme => ({
  card: {
    height: 'calc(100vh - 108px)',
    overflow: 'auto',
  },
  avatar: {
    width: 60,
    height: 60,
  },
  summaryContainer: {
    padding: theme.spacing.unit * 2,
    display: 'flex',
    flexDirection: 'row',
    'border-bottom': '1px solid #e0e0e0',
    '&:hover': {
      backgroundColor: '#ededed',
    },
  },
  nameTimeContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: theme.spacing.unit,
    maxWidth: '90%',
  },
  textContainer: {
    width: '100%',
    paddingLeft: theme.spacing.unit * 2,
  },
  selected: {
    backgroundColor: '#ededed',
  },
  unread: {
    backgroundColor: '#e0e0e0',
  },
  withStatus: {
    display: 'flex',
    flexDirection: 'column',
  },
  messagePreview: {
    maxWidth: '70%',
  },
  none: {
    width: '100%',
    display: 'flex',
    padding: theme.spacing.unit * 2,
    justifyContent: 'center',
  },
});



// WEBPACK FOOTER //
// ./src/modules/messages/cards/MessageListCard/styles.js